export default __webpack_public_path__ + "static/media/Twilio.737d409d.svg";